import DateInput from "../../../components/common/inputs/DateInput";
import { useState } from "react";
// import { utilsState } from "../../../sotre/redux/features/utilsSlice";
// import { useSelector } from "react-redux";

export default function SocialMediaCustomerReportFilter({
  filterDataHandler,
  activeSearchButton,
}) {
  const [filters, setFilters] = useState({
    from: "",
    to: "",
  });
  // const { utils } = useSelector(utilsState);
  const handleSearchClick = () => {
    filterDataHandler({ page: 1, ...filters });
  };

  return (
    <div className="w-full flex flex-col flex-wrap my-8 gap-6 px-6">
      <div className="w-full flex items-center flex-col sm:flex-row gap-6">
        <DateInput
          label={"از تاریخ"}
          onChange={(e) => setFilters((prev) => ({ ...prev, from: e }))}
        />
        <DateInput
          label={"تا تاریخ"}
          onChange={(e) => setFilters((prev) => ({ ...prev, to: e }))}
        />
        {/* <div>
          <label className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
            شبکه اجتماعی
          </label>
          <select
            onChange={(e) =>
              setFilters({ page: 1, socialGroup: e.target.value })
            }
            className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-32 p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
          >
            <option value={""}>همه</option>;
            {utils?.SOCIAL_MEDIA_TYPE_VALUES
              ? utils?.SOCIAL_MEDIA_TYPE_VALUES?.map((item) => {
                  return <option value={item?.value}>{item?.name}</option>;
                })
              : null}
          </select>
        </div> */}
        <button
          disabled={!activeSearchButton}
          onClick={handleSearchClick}
          className="text-white mt-[30px] h-10 bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm w-full sm:w-auto px-8  text-center dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800"
        >
          {activeSearchButton ? "جستجو" : "منتظر بمانید..."}
        </button>
      </div>
    </div>
  );
}
